import React, { useState, useEffect } from "react";
import { Box, Button, Grid, InputAdornment, TextField } from "@mui/material";
import { Search } from "tabler-icons-react";
import { useMediaQuery } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import OrgaCard from "./OrgaCard";
import CreateOrgaName from "../../components/CreateOrgaName";
import {
  setOrganizationId,
  getOrganizatonProfiles,
  getOrganizatonMetricsById,
} from "../../redux/actions/organizationProfileCreators";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { setUuidReport } from "../../redux/actions/reportsActionCreator";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isMobile = useMediaQuery("(max-width:1400px)");

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ width: "100%", mt: !isMobile ? 7 : 3 }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Entreprise = () => {
  const isAuth = useSelector((state) => state.user.isAuth);
  const profiles = useSelector(
    (state) => state.organizationProfile.organizationProfiles
  );
  const totalPages = useSelector(
    (state) => state.organizationProfile.totalPages
  );

  const orgaMetricsById = useSelector(
    (state) => state.organizationProfile.organizationMetricsById
  );

  const isMobile = useMediaQuery("(max-width:1400px)");
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState("");
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [orgaSelected, setOrgaSelected] = useState({});
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("");

  const orgaId = localStorage.getItem("orgaId");
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const role = storedUser.role;

  useEffect(() => {
    if (
      role === "enterprise_admin" ||
      role === "enterprise_account_manager" ||
      role === "cytailor_admin"
    ) {
      dispatch(getOrganizatonProfiles(page, searchText, status));
    }
  }, [dispatch, page, searchText, status]);

  // useEffect(() => {
  //   if (
  //     orgaId &&
  //     orgaId !== "null" &&
  //     (role === "enterprise_admin" || role === "cytailor_admin") &&
  //     orgaSelected
  //   ) {

  //   }
  // }, [orgaId]);

  useEffect(() => {
    if (orgaId && orgaId !== "null") {
      setOrgaSelected(orgaMetricsById);
      dispatch(setOrganizationId(orgaId));
    }
  }, [orgaMetricsById, orgaId]);

  const handleTabs = (event, value) => {
    setTab(value);
    setPage(1);
    if (value === 0) {
      setStatus("");
    } else if (value === 1) {
      setStatus("completed");
    } else {
      setStatus("pending");
    }
  };

  const handlePage = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleOrganizationProfile = (profile, propagation) => {
    if (
      Object.keys(orgaSelected).length > 0 &&
      orgaSelected.id === profile.id &&
      !propagation
    ) {
      setOrgaSelected({});
      storedUser.org_name = null;
      storedUser.organization_id = null;
      storedUser.recommanded_quizzes = null;

      localStorage.setItem("orgaId", null);
      localStorage.setItem("user", JSON.stringify(storedUser));
      dispatch(setOrganizationId(null));
    } else {
      setOrgaSelected(profile);
      storedUser.org_name = profile.name_A;
      storedUser.organization_id = profile.id;
      storedUser.recommanded_quizzes = profile.completed_recommended_quizzes;
      localStorage.setItem("orgaId", profile.id);
      localStorage.setItem("user", JSON.stringify(storedUser));
      dispatch(setOrganizationId(profile?.id));
      dispatch(getOrganizatonMetricsById(profile?.id));
      dispatch(setUuidReport(null));
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        display: !isAuth && "flex",
        flexDirection: !isAuth && "column",
        height: !isAuth && "100%",
        alignContent: "space-between",
        gap: 5,
      }}
    >
      <Box
        sx={{ padding: !isMobile ? "0px 54px" : "0px 15px" }}
        mt={isMobile ? 2 : 6}
      >
        <Grid container spacing={2} mt={0}>
          <Grid
            item
            sm={12}
            xs={12}
            md={
              role === "enterprise_admin" || role === "cytailor_admin" ? 9 : 12
            }
          >
            <TextField
              fullWidth
              id="outlined-start-adornment"
              placeholder={t("search")}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {" "}
                    <Search size={22} strokeWidth={2} color="#8F9BB2" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {(role === "enterprise_admin" || role === "cytailor_admin") && (
            <Grid item sm={6} xs={12} md={3}>
              <Button
                variant="contained"
                color="button"
                fullWidth
                sx={{ height: "50px" }}
                onClick={() => {
                  setOpen(true);
                }}
              >
                <AddOutlinedIcon />
                {t("create_organization")}
              </Button>
            </Grid>
          )}
        </Grid>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            mt: 5,
            width: "100%",
          }}
        >
          <Tabs
            value={tab}
            onChange={handleTabs}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label={t("all_orga")} {...a11yProps(0)} />
            {/* <Tab label={t("completed_orga")} {...a11yProps(1)} />
            <Tab label={t("pending_orga")} {...a11yProps(2)} /> */}
          </Tabs>
        </Box>
        <TabPanel value={tab} index={0} sx={{ width: "100%" }}>
          <Grid container spacing={3}>
            {profiles?.map((profile, index) => (
              <Grid key={index} item lg={4} sm={6} md={6} xs={12} sx={{ display: "flex" }}>
                <OrgaCard
                  profile={profile}
                  handleOrganizationProfile={handleOrganizationProfile}
                  orgaSelected={orgaSelected}
                  profiles={profiles}
                  page={page}
                  searchText={searchText}
                  status={status}
                  role={role}
                />
              </Grid>
            ))}
          </Grid>
        </TabPanel>
        <TabPanel value={tab} index={1} sx={{ width: "100%" }}>
          <Grid container spacing={3}>
            {profiles?.map((profile, index) => (
              <Grid key={index} item lg={4} sm={12} md={6} xs={12} sx={{ display: "flex" }}>
                <OrgaCard
                  profile={profile}
                  handleOrganizationProfile={handleOrganizationProfile}
                  orgaSelected={orgaSelected}
                  profiles={profiles}
                  page={page}
                  searchText={searchText}
                  status={status}
                  role={role}
                />
              </Grid>
            ))}
          </Grid>
        </TabPanel>
        <TabPanel value={tab} index={2} sx={{ width: "100%" }}>
          <Grid container spacing={3}>
            {profiles?.map((profile, index) => (
              <Grid key={index} item lg={4} sm={12} md={6} xs={12} sx={{ display: "flex" }}>
                <OrgaCard
                  profile={profile}
                  handleOrganizationProfile={handleOrganizationProfile}
                  orgaSelected={orgaSelected}
                  profiles={profiles}
                  page={page}
                  searchText={searchText}
                  status={status}
                  role={role}
                />
              </Grid>
            ))}
          </Grid>
        </TabPanel>

        <br />
      </Box>
      <CreateOrgaName
        open={open}
        handleClose={handleCloseModal}
        isMobile={isMobile}
      />
      <Stack
        spacing={2}
        justifyContent={isMobile ? "center" : "right"}
        direction="row"
        mr={2}
        pb={2}
      >
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, p) => handlePage(p)}
          variant="outlined"
          shape="rounded"
          color="secondary"
        />
      </Stack>
    </Box>
  );
};

export default Entreprise;
